"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ThemeClassNameProvider: function() {
        return _index.ThemeClassNameProvider;
    },
    useThemeClassName: function() {
        return _index.useThemeClassName;
    }
});
const _index = require("./ThemeClassNameContext/index");
